import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { View, Text, FlatList, TouchableOpacity, ScrollView, Animated, Easing } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../utils/Helper';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { fetchStoreInfo, getStoreInfo, placeHcomOrder } from '../../Redux/Actions/hcommerceAction';
import { StoreLevel1 } from './storeLevel1';
import { StoreLevel2 } from './storeLevel2';
import MyOrders from './myOrders';
import { setCurrentWidget } from '../../Redux/Reducers/deviceConfigReducer';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import CustomFlatList from '../../components/customFlatList';
import InfoPopupModal from '../../components/infoPopupModal';
import { CHEVRON_RIGHT } from '../../assets';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { CLICKED, EXIT, HCOMMERCE, INITIAL_LOADER_SCREEN, STORE1, STORE2 } from '../../config/Constant';
import ItemGroupedAddonsModal from './ItemGroupedAddonsModal';
import ItemAddOnsModal from './ItemAddOnsModal';

const HCommerce = ({ navigation }) => {

  const dispatch = useDispatch();

  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const hasTriggeredGoHome = useRef(false);



  const { isLoggedIn } = useSelector(state => state.appConfigSlice);
  const { currentWidget } = useSelector(state => state.deviceConfigSlice);
  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const { hcommerceStoreSkuData } = useSelector(state => state.storeInfoSlice);

  let widgetLaunchTime = new Date;
  const storeName = currentWidget?.displayName; 
  const [hcommerceSessionToken, setHCommerceSessionToken] = useState(() => generateToken("hcommerce_"));



  const [initialLoading, setInitialLoading] = useState(false);
  
  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }


  const [errorState, setErrorState] = useState({
    isError: false,
    errorMessage: ""
  })

  const toggleErrorState = (state, message) => {
    setErrorState({
      isError: state,
      errorMessage: state ? message : ""
    })
  }




  const [currentPage, setCurrentPage] = useState("StoreLevel1");

  const [storeSku, setStoreSku] = useState(currentWidget?.storeSku || null);
  const [storeData, setStoreData] = useState({});
  const [configs, setConfigs] = useState({});

  const [selectedStoreItemSubType, setSelectedStoreItemSubType] = useState({});
  const [cartItem, setCartItem] = useState([]);
  const [cartItemQuantity, setCartitemQuanitity] = useState([]);
  const [cartItemPrice, setCartItemPrice] = useState(0);

  const [selectedStoreItem, setSelectedStoreItem] = useState({});
  const [showAddOnsPopup, setShowAddOnsPopup] = useState(false);
  const [showItemDetailPage, setShowItemDetailPage] = useState(false);
  const [previousNavState, setPreviousNavState] = useState(null);

  const [showAttentionPopup, setShowAttentionPopup] = useState(false);
  const [repeatChoiceItem, setRepeatChoiceItem] = useState(null);


  const currencyCode = currencyDetails.code;

  const sortStoreData = (rawData, rawConfigs, posType) => {

    let updatedStoreData = {
      ...rawData,
      isPricingViaToast: posType && posType == "TOAST" ? true : false,
    };


    // Process configs - convert string booleans to proper format for easier use
    const processedConfigs = {
      ...rawConfigs,
      // Store settings
      allowDayGuestOrdering: rawConfigs.disableOrder !== 'true',
      disableAddRemoveItemsButtons: rawConfigs.disableAddRemoveItemsButtons === 'true',
      displayAllDeliveryLocations: rawConfigs.displayAllDeliveryLocations === 'true',
      displayDeliveryTime: rawConfigs.displayDeliveryTime === 'true',
      enableConfirmOrderPopup: rawConfigs.enableConfirmOrderPopup === 'true',
      guestCountEnabled: rawConfigs.guestCountEnabled === 'true',
      // Numeric values
      taxValue: parseFloat(rawConfigs.taxValue || 0),
      serviceCharge: parseFloat(rawConfigs.serviceCharge || 0),
      defaultGratitudePercent: parseInt(rawConfigs.defaultGratitudePercent || 15),
    };

    setStoreData(updatedStoreData);
    setConfigs(processedConfigs);
  }

  useEffect(() => {

    if (storeSku && hcommerceStoreSkuData[storeSku]?.storeData) {
      const { storeData, configs, posType } = hcommerceStoreSkuData[storeSku];

      // Check if day guest ordering is allowed
      if(configs && configs.disableOrder === 'true' && !isLoggedIn){
        if(!hasTriggeredGoHome.current){
          hasTriggeredGoHome.current = true;
          dispatch(setGoHome(true));
          dispatch(setShowLoginModal(true))
          return;
        }
      }

      sortStoreData(storeData, configs, posType);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSku, hcommerceStoreSkuData])


  const fetchStoreInfoFunc = async () => {


    const isDataAlreadyThere = !!hcommerceStoreSkuData[storeSku]?.storeData;


    !isDataAlreadyThere && setInitialLoading(true);


    const fetchStoreInfoResponse = await dispatch(fetchStoreInfo(storeSku));

    setInitialLoading(false);
    dispatch(sendAnalytics(HCOMMERCE, fetchStoreInfoResponse.status == "SUCCESS" ? "STORE INFO FETCH - SUCCESS" : "STORE INFO FETCH - FAILED", { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))
    
    if (!(fetchStoreInfoResponse.status == "SUCCESS") && !isDataAlreadyThere) {
      toggleErrorState(true, fetchStoreInfoResponse.message)
    }
  }

  useEffect(() => {
    if (storeSku) {
      fetchStoreInfoFunc();
      dispatch(sendAnalytics(HCOMMERCE, CLICKED, { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSku])

  useEffect(() => {
    if (currentWidget.storeSku) {
      setStoreSku(currentWidget.storeSku);
    }
  }, [currentWidget])

  useEffect(() => {

    return () => {
      if(storeSku){
        const widgetCloseTime = new Date;
        const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
        dispatch(sendAnalytics(HCOMMERCE, EXIT, { storeName: storeName, element: "widget", duration: widgetCloseDuration, widgetSessionId: hcommerceSessionToken }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])



  // handle cart

  const handleAddToCart = useCallback((itemInfo, selectedAddOns = [], proceedWithSelectedAddOns = false) => {

    let updatedCartItem = [...cartItem];

    // Check if the item has add-ons and Stop further execution until the user selects add-ons
    if (itemInfo.hasItemAddOns) {

      if (!proceedWithSelectedAddOns) {
        // If item already in cart, show inline repeat/customise sheet
        const existingInCart = cartItem.find(item => item.itemInfo.id === itemInfo.id);
        if (existingInCart) {
          setRepeatChoiceItem(itemInfo);
          return;
        }

        setSelectedStoreItem(itemInfo);
        if (itemInfo.addOnGroupReferences?.length > 0) {
          setShowItemDetailPage(true);
        } else {
          setShowAddOnsPopup(true);
        }
        return;
      }
    }

    const selectedQuantity = itemInfo.quantity || 1;
    const sortedSelectedAddOns = selectedAddOns.slice().sort((a, b) => a.id - b.id);

    // Check if the item with the same addOns already exists in the cart
    const existingItemIndex = updatedCartItem.findIndex(item => {
      const sortedItemAddOns = item.addOns.slice().sort((a, b) => a.id - b.id);
      return item.itemInfo.id === itemInfo.id &&
        sortedItemAddOns.length === sortedSelectedAddOns.length &&
        sortedItemAddOns.every((addOn, index) => addOn.id === sortedSelectedAddOns[index].id); // Compare ids
    });

    const unitPrice = parseFloat(itemInfo.itemPrice || 0) + selectedAddOns.reduce((sum, addOn) => sum + parseFloat(addOn.price || 0), 0);

    if (existingItemIndex !== -1) {
      updatedCartItem[existingItemIndex] = {
        ...updatedCartItem[existingItemIndex],
        quantity: updatedCartItem[existingItemIndex].quantity + selectedQuantity,
        totalPrice: updatedCartItem[existingItemIndex].totalPrice + unitPrice * selectedQuantity,
      };
    } else {

      const updatedItemInfo = {
        itemInfo,
        quantity: selectedQuantity,
        addOns: selectedAddOns,
        totalPrice: unitPrice * selectedQuantity,
      };
      updatedCartItem.push(updatedItemInfo);
    }

    setCartItem(updatedCartItem);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItem]);

  // All cart entries belonging to the repeat-choice item
  const repeatChoiceEntries = useMemo(() => {
    if (!repeatChoiceItem) return [];
    return cartItem
      .map((ci, idx) => ({ ...ci, cartIdx: idx }))
      .filter(ci => ci.itemInfo.id === repeatChoiceItem.id);
  }, [repeatChoiceItem, cartItem]);

  const handleIncrementEntry = useCallback((cartIdx) => {
    setCartItem(prev => {
      const updated = [...prev];
      if (cartIdx >= 0 && cartIdx < updated.length) {
        const entry = updated[cartIdx];
        const unitPrice = entry.quantity > 0 ? entry.totalPrice / entry.quantity : 0;
        updated[cartIdx] = { ...entry, quantity: entry.quantity + 1, totalPrice: entry.totalPrice + unitPrice };
      }
      return updated;
    });
  }, []);

  const handleDecrementEntry = useCallback((cartIdx, itemId) => {
    setCartItem(prev => {
      const updated = [...prev];
      if (cartIdx >= 0 && cartIdx < updated.length) {
        const entry = updated[cartIdx];
        if (entry.quantity <= 1) {
          updated.splice(cartIdx, 1);
          const remaining = updated.filter(ci => ci.itemInfo.id === itemId);
          if (remaining.length === 0) setRepeatChoiceItem(null);
        } else {
          const unitPrice = entry.quantity > 0 ? entry.totalPrice / entry.quantity : 0;
          updated[cartIdx] = { ...entry, quantity: entry.quantity - 1, totalPrice: entry.totalPrice - unitPrice };
        }
      }
      return updated;
    });
  }, []);

  const handleAddNewCustomisation = useCallback(() => {
    if (!repeatChoiceItem) return;
    const itemInfo = repeatChoiceItem;
    setRepeatChoiceItem(null);
    setSelectedStoreItem(itemInfo);
    if (itemInfo.addOnGroupReferences?.length > 0) {
      setShowItemDetailPage(true);
    } else {
      setShowAddOnsPopup(true);
    }
  }, [repeatChoiceItem]);

  const handleRemoveFromCart = useCallback((itemInfo = {}, itemIndex = null) => {
    let updatedCartItem = [...cartItem];

    // Find all items with the matching itemId
    const matchingItems = updatedCartItem.filter(item => item.itemInfo.id === itemInfo.id);

    if (matchingItems.length > 1 && itemIndex === null) {
      // Multiple variants in cart — show the customisation sheet to let user pick which to decrement
      setRepeatChoiceItem(itemInfo);
      return;
    }

    // If an itemIndex is provided, use it; otherwise, find the first matching item
    const targetIndex = itemIndex !== null ? itemIndex : updatedCartItem.findIndex(item => item.itemInfo.id === itemInfo.id);

    if (targetIndex !== -1) {
      const existingItem = updatedCartItem[targetIndex];

      if (existingItem.quantity > 1) {
        // Reduce the quantity and adjust the total price
        updatedCartItem[targetIndex] = {
          ...existingItem,
          quantity: existingItem.quantity - 1,
          totalPrice: existingItem.totalPrice - existingItem.totalPrice / existingItem.quantity,
        };
      } else {
        updatedCartItem.splice(targetIndex, 1);
      }
    }

    setCartItem(updatedCartItem);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItem]);


  useEffect(() => {

    let cartItemQuantity = cartItem.reduce((totalQuantity, item) => totalQuantity + +item.quantity, 0);
    setCartitemQuanitity(cartItemQuantity);


    let cartItemPrice = cartItem.reduce((totalPrice, item) => totalPrice + +item.totalPrice, 0);
    setCartItemPrice(cartItemPrice)
  }, [cartItem])






  // handle my orders page
  const handleMyOrders = () => {
    setPreviousNavState({ currentPage, selectedStoreItemSubType });
    setCurrentPage("MyOrders");
  }

  const handlePlaceOrder = async (payload) => {

    toggleLoaderState(true, "Placing order...");

    const orderResponse = await dispatch(placeHcomOrder(storeSku, payload));

    toggleLoaderState(false, "");
    dispatch(sendAnalytics(HCOMMERCE, orderResponse.status == "SUCCESS" ? "PLACE ORDER - SUCCESS" : "PLACE ORDER - FAILED", { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))

    if(orderResponse.status == "SUCCESS"){
      setCartItem([]);
      handleGoBack();
    }
  }




  // handle Item info page state
  // Routes to grouped-addon modal or flat-addon modal based on item type
  const handleItemInfo = useCallback((itemInfo) => {
    setSelectedStoreItem(itemInfo);
    if (itemInfo.addOnGroupReferences?.length > 0) {
      setShowItemDetailPage(true);   // ItemGroupedAddonsModal
    } else {
      setShowAddOnsPopup(true);      // ItemAddOnsModal
    }
  }, []);




  // handle store level 2
  const handleStoreItemSubTypeSelect = useCallback((storeItemSubType) => {
    setSelectedStoreItemSubType(storeItemSubType);
    setCurrentPage("StoreLevel2");
  }, []);



  // handle go back

  const handleClosePopup = () => {
    setShowAttentionPopup(false);
  };

  const handleGoBack = (forceGoHome = false) => {

    if (forceGoHome) {
      dispatch(setGoHome(true));
      return;
    }

    if (currentPage === "MyOrders" && previousNavState) {
      setCurrentPage(previousNavState.currentPage);
      setSelectedStoreItemSubType(previousNavState.selectedStoreItemSubType);
      setPreviousNavState(null);
      return;
    }

    if (showItemDetailPage) {
      setShowItemDetailPage(false);
      setSelectedStoreItem({});
      return;
    }

    if (showAddOnsPopup) {
      setShowAddOnsPopup(false);
      return;
    }

    if (currentPage != "StoreLevel1") {
      setCurrentPage("StoreLevel1");
      return;
    }
    if (cartItemQuantity > 0) {
      setShowAttentionPopup(true);
      return;
    }

    dispatch(setGoHome(true));
  }

  const storePages = !storeSku ? null : (
    <>
      {/* StoreLevel1 — always mounted to preserve scroll position */}
      <View style={{ flex: 1, display: currentPage === 'StoreLevel1' ? 'flex' : 'none' }}>
        <StoreLevel1
          storeData={storeData}
          handleStoreItemSubTypeSelect={handleStoreItemSubTypeSelect}
          cartItem={cartItem}
          handleItemInfo={handleItemInfo}
          handleAddToCart={handleAddToCart}
          handleRemoveFromCart={handleRemoveFromCart}
          storeName={storeName}
          hcommerceSessionToken={hcommerceSessionToken}
        />
      </View>

      {/* StoreLevel2 — mounted once user navigates to it, hidden when not active */}
      {selectedStoreItemSubType?.id && (
        <View style={{ flex: 1, display: currentPage === 'StoreLevel2' ? 'flex' : 'none' }}>
          <StoreLevel2
            storeData={storeData}
            selectedStoreItemSubType={selectedStoreItemSubType}
            handleStoreItemSubTypeSelect={handleStoreItemSubTypeSelect}
            cartItem={cartItem}
            handleItemInfo={handleItemInfo}
            handleAddToCart={handleAddToCart}
            handleRemoveFromCart={handleRemoveFromCart}
            storeName={storeName}
            hcommerceSessionToken={hcommerceSessionToken}
          />
        </View>
      )}

      {/* MyOrders — conditionally mounted, no scroll state to preserve */}
      {currentPage === 'MyOrders' && (
        <MyOrders
          storeData={storeData}
          configs={configs}
          cartItem={cartItem}
          handlePlaceOrder={handlePlaceOrder}
          handleAddToCart={handleAddToCart}
          handleRemoveFromCart={handleRemoveFromCart}
          handleGoBack={handleGoBack}
          storeName={storeName}
          hcommerceSessionToken={hcommerceSessionToken}
          currentWidget={currentWidget}
        />
      )}
    </>
  );

  let scaleAnimation = useRef(new Animated.Value(1)).current;

  // Trigger animation when cartItemQuantity updates on My order btn
  useEffect(() => {

    Animated.sequence([
      Animated.timing(scaleAnimation, {
        toValue: 1.5, // Increase size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnimation, {
        toValue: 1, // Return to original size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      })
    ]).start();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItemQuantity]);


  return (
    <View style={getStyles(['widgetRootContainer', 'hcommerceRootContainer'])}>
      <HeaderWithBack handleCustomBackPress={handleGoBack} />


      {!storeSku ?


        <View style={getStyles(['widgetmainContainer', 'hcommerceMainContainer'])}>

          <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerceHeaderContainer'])}>
            {
              currentWidget?.widgetHeaderImageUrl &&
              <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerceHeaderImg'])} />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerceHeaderTitleContainer'])}>
              <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerceHeaderTitle'])}>{t('h-commerce.select_store')}</Text>
            </View>
          </View>

          <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerceMainContainerChildContainer'])}>

            {Object.values(hcommerceStoreSkuData).map((widgetData) => {
              return (
                <CustomPressable key={widgetData.id} style={getStyles(['list_itemContainer', 'hcommerce_itemContainer'])} onPress={() => dispatch(setCurrentWidget(widgetData))}>

                  {widgetData?.widgetHeaderImageUrl && <ImageComp
                    source={getCleanUrl(widgetData?.widgetHeaderImageUrl)}
                    style={getStyles(['list_itemContainer_image', 'hcommerce_itemContainer_image'])}
                  />}

                  <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_itemContainer_textContainer'])}>
                    {widgetData?.widgetTitle && <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_itemContainer_textContainer_title'])}>{widgetData.displayName}</Text>}
                  </View>

                  <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_itemContainer_arrow'])}>
                    <ImageComp source={CHEVRON_RIGHT} />
                  </View>
                </CustomPressable>

              );
            })}

          </View>

        </View>
        :
        storePages
      }


      {showItemDetailPage && (
        <ItemGroupedAddonsModal
          selectedStoreItem={selectedStoreItem}
          addonsList={storeData.addonsList || {}}
          addOnGroupList={storeData.addOnGroupList || {}}
          configs={configs}
          handleAddToCart={handleAddToCart}
          handleClose={() => {
            setShowItemDetailPage(false);
            setSelectedStoreItem({});
          }}
        />
      )}

      {showAddOnsPopup && (
        <ItemAddOnsModal
          selectedStoreItem={selectedStoreItem}
          addonsList={storeData.addonsList || {}}
          configs={configs}
          handleAddToCart={handleAddToCart}
          handleClose={() => {
            setShowAddOnsPopup(false);
            setSelectedStoreItem({});
          }}
        />
      )}

      {/* Repeat / Customise inline sheet */}
      {repeatChoiceItem && (
        <View style={getStyles(['hcommerce_repeat_overlay'])}>
          <TouchableOpacity style={getStyles(['hcommerce_repeat_backdrop'])} activeOpacity={1} onPress={() => setRepeatChoiceItem(null)} />
          <View style={getStyles(['hcommerce_repeat_sheet'])}>
            {/* Header */}
            <View style={getStyles(['hcommerce_repeat_sheetHeader'])}>
              <Text style={getStyles(['hcommerce_repeat_sheetTitle'])}>Choose customisation</Text>
              <TouchableOpacity onPress={() => setRepeatChoiceItem(null)} style={getStyles(['hcommerce_repeat_sheetClose'])}>
                <Text style={getStyles(['hcommerce_repeat_sheetCloseText'])}>✕</Text>
              </TouchableOpacity>
            </View>
            <View style={getStyles(['hcommerce_repeat_divider'])} />

            {/* One row per cart entry for this item */}
            {repeatChoiceEntries.map(({ cartIdx, quantity, addOns, totalPrice }) => {
              const addonSummary = addOns?.map(a => a.name).filter(Boolean).join(', ');
              return (
                <View key={cartIdx} style={getStyles(['hcommerce_repeat_entryRow'])}>
                  <View style={getStyles(['hcommerce_repeat_entryInfo'])}>
                    <Text style={getStyles(['hcommerce_repeat_entryTitle'])} numberOfLines={1}>{repeatChoiceItem.itemName}</Text>
                    {addonSummary ? <Text style={getStyles(['hcommerce_repeat_entryAddons'])} numberOfLines={1}>{addonSummary}</Text> : null}
                  </View>
                  <View style={getStyles(['hcommerce_repeat_entryRight'])}>
                    <View style={getStyles(['hcommerce_repeat_entryQtyRow'])}>
                      <TouchableOpacity style={getStyles(['hcommerce_repeat_qtyBtn'])} onPress={() => handleDecrementEntry(cartIdx, repeatChoiceItem.id)}>
                        <Text style={getStyles(['hcommerce_repeat_qtyBtnText'])}>−</Text>
                      </TouchableOpacity>
                      <Text style={getStyles(['hcommerce_repeat_qtyNum'])}>{quantity}</Text>
                      <TouchableOpacity style={getStyles(['hcommerce_repeat_qtyBtn'])} onPress={() => handleIncrementEntry(cartIdx)}>
                        <Text style={getStyles(['hcommerce_repeat_qtyBtnText'])}>+</Text>
                      </TouchableOpacity>
                    </View>
                    <Text style={getStyles(['hcommerce_repeat_entryPrice'])}>{currencyCode}{parseFloat(totalPrice).toFixed(2)}</Text>
                  </View>
                </View>
              );
            })}

            <View style={getStyles(['hcommerce_repeat_divider'])} />
            {/* Add new customisation */}
            <TouchableOpacity style={getStyles(['hcommerce_repeat_addNewBtn'])} onPress={handleAddNewCustomisation}>
              <Text style={getStyles(['hcommerce_repeat_addNewBtnText'])}>+ Add new customisation</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {cartItem.length > 0 && currentPage != "MyOrders" && !showItemDetailPage &&
        <View style={getStyles(['footer_button_container', 'myOrder_container'])} id='footer_button_container myOrder_container'>
          <View style={getStyles(['myOrder_container_price_container'])} id='myOrder_container_price_container'>
            <Text style={getStyles(['myOrder_container_price_container_text'])} id='myOrder_container_price_container_text'>Total</Text>
            <Text style={getStyles(['myOrder_container_price_container_text'])} id='myOrder_container_price_container_text'>{currencyCode + cartItemPrice}</Text>
          </View>

          <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleMyOrders} id="primaryBtn">
            <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
              {t('h-commerce.my_order')} {' '}
            </Text>
            <Animated.View style={[getStyles(['myOrder_container_count_container']), { transform: [{ scale: scaleAnimation }] }]} id={"myOrder_container_count_container"}>
              <Text style={getStyles(['myOrder_container_count_container_text'])} id='myOrder_container_count_container_text'>{cartItemQuantity}</Text>
            </Animated.View>
          </CustomPressable>
        </View>
      }

      {showAttentionPopup &&
        <InfoPopupModal
          title={"Attention!"}
          subtitle={t('h-commerce.items_inCart_info')}
          onClose={handleClosePopup}
          secondaryBtnLabel={"No"}
          OnRequestClose={handleClosePopup}
          onContinue={() => handleGoBack(true)}
          primaryBtnLabel={"Yes"}
        />
      }

      {errorState.errorMessage &&
        <InfoPopupModal
          subtitle={errorState.errorMessage}
          onClose={() => {toggleErrorState(false); handleGoBack();}}
          OnRequestClose={() => {toggleErrorState(false); handleGoBack();}}
          secondaryBtnLabel={"Back"}
          onContinue={() => {toggleErrorState(false); fetchStoreInfoFunc()}}
          primaryBtnLabel={"Try again"}
        />
      }


      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

    </View>
  )
};

export default HCommerce;
